import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'

import imgFavicon from '../../assets/favicon.png'

function SEO({ description, lang, meta, keywords, title }) {
  return (
    <StaticQuery
      query={detailsQuery}
      render={data => {
        const metaDescription =
          description || data.site.siteMetadata.description
        const metaTitle = title || data.site.siteMetadata.title
        return (
          <Helmet
            htmlAttributes={{
              lang,
            }}
            script={[
              {
                type: 'application/ld+json',
                innerHTML: JSON.stringify({
                  '@context': 'https://www.schema.org',
                  '@graph': [
                    {
                      '@type': 'Organization',
                      name: 'Pointbee',
                      legalName: 'Pointbee',
                      url: 'https://pointbee.app/',
                      logo: 'https://pointbee.app/logo.png',
                      foundingDate: '2019',
                      founders: [
                        {
                          '@type': 'Person',
                          name: 'Pablo Rocha',
                        },
                        {
                          '@type': 'Person',
                          name: 'Arturo Jaime Garcia',
                        },
                        {
                          '@type': 'Person',
                          name: 'Ramon Almaguer',
                        },
                      ],
                      contactPoint: [
                        {
                          '@type': 'ContactPoint',
                          contactType: 'customer service',
                          telephone: '+1 (956) 624-0448',
                          email: 'hello@dotdotdata.com',
                        },
                        {
                          '@type': 'ContactPoint',
                          contactType: 'sales',
                          telephone: '+1 (956) 624-0448',
                          email: 'hello@dotdotdata.com',
                        },
                      ],
                      sameAs: [
                        'https://play.google.com/store/apps/details?id=com.dotdotdata.pointbee',
                        'https://apps.apple.com/app/id1455555114',
                        'https://facebook.com/pointbeeapp',
                        'https://instagram.com/pointbee.app',
                      ],
                    },
                    {
                      '@type': 'SoftwareApplication',
                      name: 'Pointbee',
                      operatingSystem: ['ANDROID', 'IOS'],
                      applicationCategory: 'https://schema.org/GameApplication',
                      aggregateRating: {
                        '@type': 'AggregateRating',
                        ratingValue: '5',
                        ratingCount: '16',
                      },
                      offers: {
                        '@type': 'Offer',
                        price: '0',
                        priceCurrency: 'USD',
                      },
                    },
                  ],
                }),
              },
            ]}
            title={metaTitle}
            meta={[
              {
                name: 'description',
                content: metaDescription,
              },
              {
                property: 'og:title',
                content: metaTitle,
              },
              {
                property: 'og:description',
                content: metaDescription,
              },
              {
                property: 'og:type',
                content: 'website',
              },
              {
                property: 'og:image',
                content: 'https://pointbee.app/open-graph.png',
              },
              {
                name: 'twitter:card',
                content: 'summary',
              },
              {
                name: 'twitter:creator',
                content: data.site.siteMetadata.author,
              },
              {
                name: 'twitter:title',
                content: metaTitle,
              },
              {
                name: 'twitter:description',
                content: metaDescription,
              },
              {
                property: 'twitter:image',
                content: 'https://pointbee.app/open-graph.png',
              },
            ]
              .concat(
                keywords.length > 0
                  ? {
                      name: 'keywords',
                      content: keywords.join(', '),
                    }
                  : []
              )
              .concat(meta)}
          >
            <link rel="icon" type="image/png" href={imgFavicon} />
          </Helmet>
        )
      }}
    />
  )
}

SEO.defaultProps = {
  lang: 'en',
  meta: [],
  keywords: [],
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.array,
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
}

export default SEO

const detailsQuery = graphql`
  query DefaultSEOQuery {
    site {
      siteMetadata {
        title
        description
        author
      }
    }
  }
`
